
const initialState = {
    objectPosition: 30,
    sdd: null,

    xRaySourceType: null,
    photonCount: 20,
    voltageMin: 60,
    voltageMax: 100,

    orientationPhi: null,
    orientationTheta: null,
    displacementX: null,
    displacementY: null,
    displacementZ: null,
    rotationCount: 20,

    detectorType: null,

    optionProjection: false,
    optionSinogram: false,
    optionMaterialmesh: false,
    optionQFactor: false,
    optionPablo: false,
}



//-----------------------------------------------------------------



const reducer = (state = initialState, action) => {
    switch (action.type) {

        case "CT-PARAMS:SUBMIT":
            return Object.assign({}, state, {
                objectPosition: action.value.objectPosition,
                sdd: action.value.sdd,

                xRaySourceType: action.value.xRaySourceType,
                photonCount: action.value.photonCount,
                voltageMin: action.value.voltageMin,
                voltageMax: action.value.voltageMax,

                orientationPhi: action.value.orientationPhi,
                orientationTheta: action.value.orientationTheta,
                displacementX: action.value.displacementX,
                displacementY: action.value.displacementY,
                displacementZ: action.value.displacementZ,
                rotationCount: action.value.rotationCount,

                detectorType: action.value.detectorType,

                optionProjection: action.value.optionProjection,
                optionSinogram: action.value.optionSinogram,
                optionMaterialmesh: action.value.optionMaterialmesh,
                optionQFactor: action.value.optionQFactor,
                optionPablo: action.value.optionPablo,
            });

        default:
            return state;
    }
}

export { reducer }
